/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_More_GuideInputs */

const en_directory_mcp_more_guide = /** @type {(inputs: Directory_Mcp_More_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent guide`)
};

const zh_directory_mcp_more_guide = /** @type {(inputs: Directory_Mcp_More_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 指引`)
};

/**
* | output |
* | --- |
* | "Agent guide" |
*
* @param {Directory_Mcp_More_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_more_guide = /** @type {((inputs?: Directory_Mcp_More_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_More_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_more_guide(inputs)
	return zh_directory_mcp_more_guide(inputs)
});
export { directory_mcp_more_guide as "directory.mcp.more_guide" }